import { createTheme } from "@mui/material";

const lightTheme = createTheme({
	palette: {
		primary: {
			main: "#9300FF",
		},
		secondary: {
			main: "#9C2CFC",
		},
		text: {
			primary: "#000000",
			secondary: "rgba(0, 0, 0, 0.8)",
			disabled: "rgba(0, 0, 0, 0.6)",
		},
		grey: { 600: "#6F6C90" },
		background: {
			paper: "#FFFFFF",
			default: "#FFFFFF",
		},
	},
	typography: {
		fontFamily: "Figtree, sans-serif",

		h3: {
			fontSize: "36px",
			fontWeight: 700,
		},
		h5: {
			fontSize: "18px",
			fontWeight: 700,
		},
		h6: {
			fontSize: "18px",
			fontWeight: 500,
		},

		subtitle1: {
			fontSize: "20px",
			fontWeight: 600,
		},
		body1: {
			fontSize: "16px",
			fontWeight: 400,
		},
	},
});

export default lightTheme;
